__turbopack_context__.v({
  "avatar": "Details-module__6HBouG__avatar",
  "contactContainer": "Details-module__6HBouG__contactContainer",
  "container": "Details-module__6HBouG__container",
  "containerLandscape": "Details-module__6HBouG__containerLandscape" + " " + "Details-module__6HBouG__container",
  "infoContainer": "Details-module__6HBouG__infoContainer",
  "number": "Details-module__6HBouG__number",
  "textContainer": "Details-module__6HBouG__textContainer",
});
